import { defineMessages } from 'react-intl';

const scope =
  'app.containers.WorkflowEditor.components.StageDetail.BackgroundCheckStage.ActionsCard';

export const messages = defineMessages({
  actions: {
    id: `${scope}.actions`,
    defaultMessage: 'Actions',
  },
  applicantMoveRule: {
    id: `${scope}.applicantMoveRule`,
    defaultMessage: 'Applicant move rule',
  },
  customStage: {
    id: `${scope}.customStage`,
    defaultMessage: 'Custom stage',
  },
  keepApplicantInThisStage: {
    id: `${scope}.keepApplicantInThisStage`,
    defaultMessage: 'Keep the applicant in this stage (recommended)',
  },
  runCheckAfterSubmitted: {
    id: `${scope}.runCheckAfterSubmitted`,
    defaultMessage:
      'Run Background Check after consent has been submitted (recommended)',
  },
  selectWhatHappensAfterConsentSubmitted: {
    id: `${scope}.selectWhatHappensAfterConsentSubmitted`,
    defaultMessage:
      'Select what happens after applicant consent has been submitted',
  },
  moveFromCustomStageIfClearOrConsider: {
    id: `${scope}.moveFromCustomStageIfClearOrConsider`,
    defaultMessage:
      'Move applicants FROM a selected custom stage if their background check results are Clear or Consider (Engaged)',
  },
  advanceWhenCheckRun: {
    id: `${scope}.advanceWhenCheckRun`,
    defaultMessage: 'Advance when Background Check has run',
  },
  advanceRegardlessOfStatus: {
    id: `${scope}.advanceRegardlessOfStatus`,
    defaultMessage:
      'Advance when Background Check has run regardless of the final status',
  },
  advanceWhenStatusClearConsiderSuspended: {
    id: `${scope}.advanceWhenStatusClearConsiderSuspended`,
    defaultMessage:
      'Advance when Background Check has run and status is Clear, Consider, or Suspended',
  },
  advanceWhenClearConsider: {
    id: `${scope}.advanceWhenClearConsider`,
    defaultMessage:
      'Advance when Background Check has run and status is Clear or Consider (Engaged)',
  },
  advanceWhenClear: {
    id: `${scope}.advanceWhenCLear`,
    defaultMessage: 'Advance when Background Check has run and status is Clear',
  },
  advanceWhenClearConsiderPostAdverse: {
    id: `${scope}.advanceWhenClearConsiderPostAdverse`,
    defaultMessage:
      'Advance when Background Check has run and status is Clear, Consider (Engaged), or Consider (Post Adverse Action)',
  },
  selectCustomStage: {
    id: `${scope}.selectCustomStage`,
    defaultMessage: 'Select a custom stage',
  },
  onceApplicantConsentsRunBackgroundCheck: {
    id: `${scope}.onceApplicantConsentsRunBackgroundCheck`,
    defaultMessage:
      'Once applicant consents, Checkr will run Background Check and:',
  },
  selectActionOnceApplicantConsents: {
    id: `${scope}.selectActionOnceApplicantConsents`,
    defaultMessage: 'Select what action to take once the applicant consents.',
  },
  doNotRunCheckAfterConsentSubmitted: {
    id: `${scope}.doNotRunCheckAfterConsentSubmitted`,
    defaultMessage:
      'Do not run Background Check after consent has been submitted',
  },
  advanceWhenApplicantSubmittedConsent: {
    id: `${scope}.advanceWhenApplicantSubmittedConsent`,
    defaultMessage: 'Advance when applicant has submitted the consent form',
  },
});
